import { render, staticRenderFns } from "./PptxPreview.vue?vue&type=template&id=7849152c&scoped=true"
import script from "./PptxPreview.vue?vue&type=script&lang=js"
export * from "./PptxPreview.vue?vue&type=script&lang=js"
import style0 from "./PptxPreview.vue?vue&type=style&index=0&id=7849152c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7849152c",
  null
  
)

export default component.exports